/*
 * @Author: your name
 * @Date: 2020-09-28 16:57:56
 * @LastEditTime: 2021-06-24 16:40:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\commons\bannerService.ts
 */
import { Banner } from './bannerModel'
import instance from '@/service'
import { ResponseCode } from '@/commons/enums'
export class BannerService {
  async getBannerService (): Promise<Banner[]> {
    const response = await instance.get('/api/v1/home-index/config?key=web-index-banner')
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return []
    }
    (response as any).data = response.data
    const data = response.data
    return data.map((item: any) => {
      const dataItemArr = item.relatedId.split('@#')
      const url = dataItemArr[0] || ''
      const link = dataItemArr[1] || ''
      const publish = dataItemArr[2] === 'true'
      return new Banner(link, url, publish)
    }).filter((item: Banner) => item.publish)
  }

  // 获取新闻标题
  async getNewsService () {
    const res = await instance.get('/api/v1/menu/homePage/')
    if (res && res.data && res.data.items) {
      // this.submenus = res.data.items
      console.log('items', res.data.items)
      return res.data.items
    }
  }

  // 获取项目体系
  async getProjectSystemService (pid: any) {
    const res = await instance.get(`/api/v2/projecsystem/?pid=${pid}`)
    console.log(res.data)
    return res.data
  }

  // 获取项目体系详情
  async getProjectSystemInforService (projectSystemId: any) {
    const res = await instance.get(`/api/v2/projecsystem/?pid=${projectSystemId}`)
    const child = res.data
    console.log(child)
    return child
  }
}
